import { Component, Input, OnInit, inject } from '@angular/core';
import { ClrDatagridSortOrder, ClrLoadingState } from '@clr/angular';
import { Floorplan, Hallway, Room } from '../../models/bim-floor-plan';
import { Customer } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';

@Component({
  selector: 'app-bms-floorplan-editor',
  templateUrl: './bms-floorplan-editor.component.html',
  styleUrls: ['./bms-floorplan-editor.component.scss']
})
export class FloorplanEditorComponent implements OnInit{

  @Input() nodeId : string;
  @Input() nodeTypeId : string;
  @Input() customer : Customer;
  @Input() saveEnabled : boolean = false;

  _floorPlan: Floorplan;
  @Input()
  get floorPlan(): Floorplan {
    return this._floorPlan;
  }
  set floorPlan(flooraPlan: Floorplan) {
    this._floorPlan = flooraPlan;
    this.updateFloorplan();
  }

  sizeOptions = [10, 20, 50, 100];
  ascSort = ClrDatagridSortOrder.ASC;

  nrRooms = 0;
  includeHallway = false;

  loadingFloorPlan : ClrLoadingState = ClrLoadingState.DEFAULT;
  showSaved : boolean = false;

  constructor()
  {
    //this.initFloorplan();
  }


  ngOnInit(): void {

  }

  async updateFloorplan() {
    this.nrRooms = this.floorPlan.rooms.length;
  }

  calcBoundingBoxMinX()
  {
    let min = 10000;
    for(let room of this.floorPlan.rooms)
    {
      let lmin = Math.min( room.area.position_x, room.area.position_x+room.area.size_x );
      min = Math.min(lmin, min);
    }
    return min;
  }

  calcBoundingBoxMinY()
  {
    let min = 10000;
    for(let room of this.floorPlan.rooms)
    {
      let lmin = Math.min( -room.area.position_y, -room.area.position_y-room.area.size_y );
      min = Math.min(lmin, min);
    }
    return min;
  }

  calcBoundingBoxMaxX()
  {
    let max = -10000;
    for(let room of this.floorPlan.rooms)
    {
      let lmax = Math.max( room.area.position_x, room.area.position_x+room.area.size_x );
      max = Math.max(lmax, max);
    }
    return max;
  }

  calcBoundingBoxMaxY()
  {
    let max = -10000;
    for(let room of this.floorPlan.rooms)
    {
      let lmax = Math.max( -room.area.position_y, -room.area.position_y-room.area.size_y );
      max = Math.max(lmax, max);
    }
    return max;
  }


  updatePlan()
  {
    let oldNrRooms = this.floorPlan.rooms.length;
    let oldNrHalways = this.floorPlan.hallways.length;

    this.floorPlan.rooms.length = this.nrRooms;
    this.floorPlan.hallways.length = this.includeHallway ? 1 : 0;

    for(let i = oldNrRooms; i < this.floorPlan.rooms.length; i++)
    {
      this.floorPlan.rooms[i] = new Room();
      this.floorPlan.rooms[i].matchesSuffix = (i+1).toString().padStart(2, "0");
    }
    for(let i = oldNrHalways; i < this.floorPlan.hallways.length; i++)
    {
      this.floorPlan.hallways[i] = new Hallway();
    }
  }

}
